<template>
  <div class="list-container" v-if="list.length">
    <div class="item-content" v-for="item in list" :key="item.id">
      <WeaponItem :weapon-info="item" />
    </div>
  </div>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
import WeaponItem from "../../../weaponList/components/item";

export default {
  mixins: [responsiveMixin],
  components: { WeaponItem },
  data() {
    return {};
  },
  props: {
    list: {
      type: Array,
      default: () => []
    }
  },
  mounted() { },
  beforeDestroy() { },
  methods: {},
  watch: {
    list: {
      handler(newValue) { },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
